import React from "react";

import search from "../../images/icons/search.png"
import vpn_key from "../../images/icons/vpn_key.png"
import update from "../../images/icons/update.png"
import dot3 from "../../images/icons/dot3.png"
 
import { BsArrowUp, BsChevronDoubleRight, BsChevronRight } from "react-icons/bs";

import { Link } from "react-router-dom"; 
import { Button } from "bootstrap";
import UserSingle from "./UserSingle";

const Users = [
    {
        id: 100,
        selected: false,
        name: "Julian Leudesdorff",
        email: "julian.leudesdorff@powerjames.com", 
        roles: "Administrator, User", 
        Status: "Active", 
        wallboxes: ['POJ-103949543129','POJ-103949543129',], 
       
    },
    {
        id: 101,
        selected: false,
        name: "Julian Leudesdorff",
        email: "julian.leudesdorff@powerjames.com", 
        roles: "Administrator, User", 
        Status: "Active", 
        wallboxes: ['POJ-103949543129',], 
       
    },
    {
        id: 102,
        selected: false,
        name: "Julian Leudesdorff",
        email: "julian.leudesdorff@powerjames.com", 
        roles: "Administrator, User", 
        Status: "Active", 
        wallboxes: ['POJ-103949543129',], 
       
    },
    {
        id: 103,
        selected: false,
        name: "Julian Leudesdorff",
        email: "julian.leudesdorff@powerjames.com", 
        roles: "Administrator, User", 
        Status: "Active", 
        wallboxes: ['POJ-103949543129',], 
       
    },
    {
        id: 104,
        selected: false,
        name: "Julian Leudesdorff",
        email: "julian.leudesdorff@powerjames.com", 
        roles: "Administrator, User", 
        Status: "Active", 
        wallboxes: ['POJ-103949543129',], 
       
    },
    {
        id: 105,
        selected: false,
        name: "Julian Leudesdorff",
        email: "julian.leudesdorff@powerjames.com", 
        roles: "Administrator, User", 
        Status: "Active", 
        wallboxes: ['POJ-103949543129',], 
       
    },
    {
        id: 106,
        selected: false,
        name: "Julian Leudesdorff",
        email: "julian.leudesdorff@powerjames.com", 
        roles: "Administrator, User", 
        Status: "Active", 
        wallboxes: ['POJ-103949543129',], 
       
    },
    {
        id: 107,
        selected: false,
        name: "Julian Leudesdorff",
        email: "julian.leudesdorff@powerjames.com", 
        roles: "Administrator, User", 
        Status: "Active", 
        wallboxes: ['POJ-103949543129',], 
       
    },
    {
        id: 108,
        selected: false,
        name: "Julian Leudesdorff",
        email: "julian.leudesdorff@powerjames.com", 
        roles: "Administrator, User", 
        Status: "Active", 
        wallboxes: ['POJ-103949543129',], 
       
    },
    {
        id: 109,
        selected: false,
        name: "Julian Leudesdorff",
        email: "julian.leudesdorff@powerjames.com", 
        roles: "Administrator, User", 
        Status: "Active", 
        wallboxes: ['POJ-103949543129',], 
       
    },
    {
        id: 110,
        selected: false,
        name: "Julian Leudesdorff",
        email: "julian.leudesdorff@powerjames.com", 
        roles: "Administrator, User", 
        Status: "Active", 
        wallboxes: ['POJ-103949543129',], 
       
    },
    {
        id: 111,
        selected: false,
        name: "Julian Leudesdorff",
        email: "julian.leudesdorff@powerjames.com", 
        roles: "Administrator, User", 
        Status: "Active", 
        wallboxes: ['POJ-103949543129',], 
       
    },
    {
        id: 112,
        selected: false,
        name: "Julian Leudesdorff",
        email: "julian.leudesdorff@powerjames.com", 
        roles: "Administrator, User", 
        Status: "Active", 
        wallboxes: ['POJ-103949543129',], 
       
    },
    {
        id: 113,
        selected: false,
        name: "Julian Leudesdorff",
        email: "julian.leudesdorff@powerjames.com", 
        roles: "Administrator, User", 
        Status: "Active", 
        wallboxes: ['POJ-103949543129',], 
       
    }, 
    {
        id: 114,
        selected: false,
        name: "Julian Leudesdorff",
        email: "julian.leudesdorff@powerjames.com", 
        roles: "Administrator, User", 
        Status: "Active", 
        wallboxes: ['POJ-103949543129',], 
       
    },
    {
        id: 115,
        selected: false,
        name: "Julian Leudesdorff",
        email: "julian.leudesdorff@powerjames.com", 
        roles: "Administrator, User", 
        Status: "Active", 
        wallboxes: ['POJ-103949543129',], 
       
    },
    {
        id: 116,
        selected: false,
        name: "Julian Leudesdorff",
        email: "julian.leudesdorff@powerjames.com", 
        roles: "Administrator, User", 
        Status: "Active", 
        wallboxes: ['POJ-103949543129',], 
       
    },
    {
        id: 117,
        selected: false,
        name: "Julian Leudesdorff",
        email: "julian.leudesdorff@powerjames.com", 
        roles: "Administrator, User", 
        Status: "Active", 
        wallboxes: ['POJ-103949543129',], 
       
    },
    

];

// Sorting function
const sortedList = (data, order, item) => {
    if (order === 'up') {
        return data.sort((a, b) => (a[item] ? 1 : -1));
    }
    if (order === 'down') {
        return data.sort((a, b) => (a[item] ? -1 : 1));
    }
}

class UserData extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            List: Users,
            MasterChecked: false,
            SelectedList: [],
            show: false,
            currentSort: 'up'
        };
    }

    handleModal() {
        this.setState({ show: !this.state.show })
    }

    // Select/ UnSelect Table rows
    onMasterCheck(e) {
        let tempList = this.state.List;
        // Check/ UnCheck All Items
        tempList.map((user) => (user.selected = e.target.checked));

        //Update State
        this.setState({
            MasterChecked: e.target.checked,
            List: tempList,
            SelectedList: this.state.List.filter((e) => e.selected),
        });
    }

    // Update List Item's state and Master Checkbox State
    onItemCheck(e, item) {
        let tempList = this.state.List;
        tempList.map((user) => {
            if (user.id === item.id) {
                user.selected = e.target.checked;
            }
            return user;
        });

        //To Control Master Checkbox State
        const totalItems = this.state.List.length;
        const totalCheckedItems = tempList.filter((e) => e.selected).length;

        // Update State
        this.setState({
            MasterChecked: totalItems === totalCheckedItems,
            List: tempList,
            SelectedList: this.state.List.filter((e) => e.selected),
        });
    }

    // Event to get selected rows(Optional)
    getSelectedRows() {
        this.setState({
            SelectedList: this.state.List.filter((e) => e.selected),
        });
    }

    onSortChange = () => {
        const { currentSort } = this.state;
        let nextSort;

        if (currentSort === 'down') nextSort = 'up';
        else if (currentSort === 'up') nextSort = 'down';

        this.setState({
            currentSort: nextSort,
        });

    };

    render() {
        return (
            <>
                <div className="table-componet">
                    <div className="row">
                        <div className="col-md-12"> 
                            <div className="tab__content"> 
                                <table className="table box-table user_table">
                                    <thead>
                                        <tr>
                                            <th scope="col">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    checked={this.state.MasterChecked}
                                                    id="mastercheck"
                                                    onChange={(e) => this.onMasterCheck(e)}
                                                />
                                            </th>
                                            <th onClick={this.onSortChange} scope="col" className="id">
                                                <span className="d-installed">ID  <BsArrowUp/></span>
                                            </th> 
                                            <th scope="col" className="serialT">Name</th> 
                                            <th scope="col" className="FirmwareT">E-Mail</th>
                                            <th scope="col" className="Energy_T">Password </th>
                                            <th scope="col" className="statusT">Status</th>
                                            <th scope="col" className="Energy_T">Roles </th>
                                            <th scope="col" className="ownerT">Wallboxes </th>
                                            <th scope="col" className="ownerT">Konten </th>
                                            <th scope="col"></th> 
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {sortedList(this.state.List, this.state.currentSort, 'id').map((user) => (
                                            <tr key={user.id} className={user.selected ? "selected" : ""}>
                                                <th scope="row">
                                                    <input
                                                        type="checkbox"
                                                        checked={user.selected}
                                                        className="form-check-input"
                                                        id="rowcheck{user.id}"
                                                        onChange={(e) => this.onItemCheck(e, user)}
                                                    />
                                                </th>
                                                <td><span>{user.id}</span></td>
                                                <td className="wallboxSerial"><span><Link to="/user_single">{user.name}</Link></span></td>
                                                <td className="FirmwareVersion"><span>{user.email}</span></td>
                                                <td className="reset_pass"><span> <img src={vpn_key} /> Reset Password</span></td>
                                                <td className="Stat"><span className={user.Status}>{user.Status}</span></td>
                                                <td className="roles_tt"><span>{user.roles}</span></td>
                                                <td className="wallboxes_tt">
                                                    <span className="">
                                                       
                                                        {
                                                           user.wallboxes.length === 1 &&  <button className="box_dot">  {user.wallboxes} </button>
                                                        }
                                                         
                                                        {user.wallboxes.length > 1 && (
                                                            <button className="box_dot"> 
                                                                <img src={dot3}/> {user.wallboxes.length} Wallboxes
                                                            </button>
                                                        )}
                                                    </span>
                                                </td> 
                                                <td className="konten">
                                                    <span>
                                                        <button className="konten_btn">Geschäftlich</button>
                                                        <button className="konten_btn">Privat</button>
                                                    </span>
                                                </td>
                                                <td className="Search">
                                                    <span>  
                                                        <button><img src={search} /></button>
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="pagination-content">
                        <ul> 
                            <li>1</li>
                            <li className="active">2</li>
                            <li>3</li>
                            <li>4</li>
                            <li><BsChevronDoubleRight /></li> 
                        </ul>
                        <div className="pageRight">
                            <span>Showing 20 of 320 items</span>
                        </div>
                    </div>
                </div>

            </>
        );
    }
}

export default UserData;